import { PawPrint } from "lucide-react";
import { cn } from "@/lib/utils";

interface BrandProps {
  /** Show icon with text */
  showIcon?: boolean;
  /** Size variant */
  size?: "sm" | "md" | "lg";
  /** Additional className */
  className?: string;
  /** Include .pl suffix */
  withDomain?: boolean;
}

/**
 * Consistent brand component for "GdzieSchronisko" across the app.
 * Uses Nunito font and primary color for consistent branding.
 */
export const Brand = ({ 
  showIcon = false, 
  size = "md", 
  className,
  withDomain = false 
}: BrandProps) => {
  const sizeClasses = {
    sm: "text-base",
    md: "text-lg",
    lg: "text-xl",
  };

  const iconSizes = {
    sm: "w-6 h-6",
    md: "w-8 h-8",
    lg: "w-10 h-10",
  };

  const iconInnerSizes = {
    sm: "w-3 h-3",
    md: "w-4 h-4",
    lg: "w-5 h-5",
  };

  return (
    <span className={cn("inline-flex items-center gap-2", className)}>
      {showIcon && (
        <span className={cn("bg-primary rounded-lg flex items-center justify-center", iconSizes[size])}>
          <PawPrint className={cn("text-primary-foreground", iconInnerSizes[size])} />
        </span>
      )}
      <span className={cn("font-bold text-primary", sizeClasses[size])}>
        GdzieSchronisko{withDomain && ".pl"}
      </span>
    </span>
  );
};

/** Brand name constant for SEO and text usage */
export const BRAND_NAME = "GdzieSchronisko";
export const BRAND_DOMAIN = "GdzieSchronisko.pl";
export const BRAND_TAGLINE = "Mapa Schronisk dla Zwierząt w Polsce";
